import { h } from 'preact';
import {
    Button,
    Title,
    SpotTimer,
    Row,
    Column,
    MetaLabel,
    MetaLabels,
    Steps,
    Step,
    Product,
    Event,
    Membership,
} from './components';
import {CustomerProvider, EventProvider, StepsProvider} from './contexts'

import './index.css';
import EventContext, {useEventContext} from "./contexts/EventContext";
import {useEffect, useRef, useState} from "preact/hooks";
import StepsContext from "./contexts/StepsContext";
import 'react-loading-skeleton/dist/skeleton.css'
import CustomerContext from "./contexts/CustomerContext";
import Skeleton from "react-loading-skeleton";

export default function App({ dataWidget, productId, customerEmail, customerId, modalActive, navBar, test }) {

    if (! test) {
        return <></>;
    }

    if (typeof modalActive === 'string') {
        modalActive = modalActive.toLowerCase() === 'true';
    }

    const domNode = document.querySelector(`[data-widget="${dataWidget}"]`);
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes') {
                const attrValue = mutation.target.dataset.propModalActive;
                setShowModal(attrValue.toLowerCase() === 'true');
            }
        });
    });
    observer.observe(domNode, {
        attributes: true,
        attributeFilter: ['data-prop-modal-active']
    });

    const [top, setTop] = useState(0);
    const [ showModal, setShowModal ] = useState(modalActive);
    const modalClasses = [
        showModal ? 'esc-ii-flex' : 'esc-ii-hidden',
        'esc-ii-bg-white',
        'esc-ii-flex-col',
        'esc-ii-w-full',
        'esc-ii-z-10',
        'esc-ii-fixed',
        'esc-ii-h-full',
        'esc-ii-w-full',
        'esc-ii-overflow-y-auto',
        'esc-ii-pb-20',
        'lg:esc-ii-pb-14',
        'lg:esc-ii-shadow',
        'lg:esc-ii-max-w-[1320px]',
        'lg:esc-ii-max-h-[900px]',
        'lg:esc-ii-inset-2/4',
        'lg:-esc-ii-translate-y-[50%]',
        'lg:-esc-ii-translate-x-2/4',
    ];

    useEffect(() => {
        const body = document.querySelector('body');
        if (showModal) {
            body.style.overflowY = 'hidden';
            body.classList.add('is-locked');
        } else {
            body.style.overflowY = 'auto';
            body.classList.remove('is-locked');
        }
    }, [showModal]);

    useEffect(() => {
        const navBarEle = document.querySelector(navBar);
        if (navBarEle) {
            setTop(navBarEle.getBoundingClientRect().bottom);
        }
    }, []);

    const modalRef = useRef(null);

    return (
        <>
            <div className={`esc-ii-hidden esc-ii-fixed esc-ii-left-0 esc-ii-bottom-0 esc-ii-z-10 esc-ii-w-full esc-ii-h-full esc-ii-bg-black esc-ii-opacity-20${showModal ? ' lg:esc-ii-block' : ''}`}></div>
            <div style={{ top }} className={modalClasses.filter(Boolean).join(' ')} ref={modalRef}>
                <EventProvider productId={productId}>
                    <CustomerProvider customerEmail={customerEmail} customerId={customerId}>
                        <StepsProvider>
                            <SpotTimer mobileOnly={true}/>
                            <Row collapse={false} className="esc-ii-justify-between esc-ii-mx-4 lg:esc-ii-mx-28 lg:esc-ii-mt-10 lg:esc-ii-mb-5">
                                <Column>
                                    <Steps.Back />
                                </Column>
                                <Column className="esc-ii-items-end">
                                    <Button.Close onClick={() => {
                                        setShowModal(false);
                                        domNode.dataset.propModalActive = 'false';
                                    }} />
                                </Column>
                            </Row>
                            <Row className="esc-ii-mx-4 lg:esc-ii-mx-28 esc-ii-pb-[100px] lg:esc-ii-pb-0">
                                <Column className="lg:esc-ii-pr-7 lg:esc-ii-flex-1">
                                    <Title text="Registration" />
                                    <Event.Title />
                                    <EventContext.Consumer>
                                        {({ event }) => (
                                            <>
                                                {Object.keys(event).length !== 0 ? (
                                                    <MetaLabels>
                                                        {Array.isArray(event.age_groups) && event.age_groups.length > 0 ? (
                                                            <MetaLabel>
                                                                Ages <strong>{event.age_groups.filter((age_groups) => age_groups !== '18+').join(', ')}</strong>
                                                            </MetaLabel>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </MetaLabels>
                                                ) : (
                                                    <Skeleton />
                                                )}
                                            </>
                                        )}
                                    </EventContext.Consumer>


                                    <Steps>
                                        <Steps.Navigation desktopOnly={true} />
                                        <Step title="Dates &amp; Length" name="dates_length">
                                            <Event.CourseType label={`Programme Type`} />
                                            <Event.AvailableStartDates />
                                            <Event.Duration />
                                            <Event.ProgrammeSummary />
                                            <Event.OptionalAddFeatures />
                                            <Event.OptionalAddOns />
                                            <Event.Quantity />
                                            <StepsContext.Consumer>
                                                {({ goToNextStep, getActiveStep }) => (
                                                    <EventContext.Consumer>
                                                        {({ initAttendees, isStepValid  }) => (
                                                            <CustomerContext.Consumer>
                                                                {({ customer }) => (
                                                                    <Step.NextButton
                                                                        mobileOnly={true}
                                                                        title="Confirm &amp; Specify Attendee Details"
                                                                        disabled={!isStepValid(getActiveStep())}
                                                                        onClick={() => {
                                                                            if (isStepValid(getActiveStep())) {
                                                                                initAttendees(customer);
                                                                                goToNextStep();
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            </CustomerContext.Consumer>
                                                        )}
                                                    </EventContext.Consumer>
                                                )}
                                            </StepsContext.Consumer>
                                        </Step>

                                        <Step title="Attendee Details" name="attendee_details">
                                            <Event.AttendeesForm />
                                            <Steps.ContextualSubmit mobileOnly={true} />
                                        </Step>
                                    </Steps>
                                </Column>

                                <Column className="lg:esc-ii-pl-7 lg:esc-ii-flex-1" desktopOnly={true}>
                                    <Product.Image />
                                    <SpotTimer />
                                    <Event.Summary />
                                    <Event.Total />
                                    <Steps.ContextualSubmit desktopOnly={true} />
                                </Column>
                            </Row>
                            <Event.Summary.Fixed navBar={navBar} modalRef={modalRef} />
                        </StepsProvider>
                    </CustomerProvider>
                </EventProvider>
            </div>
        </>
    );
}
